/* eslint-disable react-hooks/exhaustive-deps */
import { loginUser, showVerificationModal } from 'features/login/store/login.action';
import { ErrorCodes, LoginErrors } from 'features/login/util/utility';
import { useBiometry } from 'features/webView/components/hooks/useBiometry';
import { LoginData } from 'features/webView/components/hooks/useBiometry/interface';
import { t } from 'i18next';
import { FC, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { APP_URL } from 'shared/constants/common';
import { decryptData, getUserDetails, isAndroidNewApp, showModalForUnverifiedAccount } from 'shared/util/utility';
import { CouponState, State } from '../../../../shared/interface';

const AutoBiometricLogin: FC = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const { triggerSetLoginFailed, triggerBiometricScan, subscribeToBiometricScan, triggerNewBiometricSession, triggerSetIsBiometryEnabled } =
		useBiometry();
	const signInData = decryptData(localStorage.getItem('keepSignedIn'));
	const isBiometryEnabled = localStorage.getItem('enableBiometry') === 'true';
	const [loginMessage, setLoginMessage] = useState<string>('');
	const coupon = useSelector<State, CouponState>((state) => state.coupon);
	const userDetails = getUserDetails();

	const userData = {
		email: signInData?.login || '',
		password: signInData?.password || '',
	};

	const handleBiometricSuccess = useCallback(
		async (loginData?: LoginData) => {
			try {
				const resp: any = await dispatch(
					loginUser(
						{
							login: loginData?.email || '',
							password: loginData?.password || '',
							keepSignedIn: signInData?.keepSignedIn,
						},
						coupon,
					),
				);
				if (resp && !resp.isError) {
					if (showModalForUnverifiedAccount(userDetails)) dispatch(showVerificationModal());
					if (isBiometryEnabled) {
						triggerNewBiometricSession(userData);
						triggerSetIsBiometryEnabled(true);
					} else {
						triggerSetIsBiometryEnabled(false);
					}
				} else {
					if (resp && resp.isError) {
						const errors = `${t(LoginErrors.get(resp.code) || 'genericErrorMessage')} ${
							resp.code === ErrorCodes.selfExclusion ? resp.message : ''
						}`;
						setLoginMessage(errors);
						history.push({
							pathname: APP_URL.login,
							state: { errorMessage: errors || loginMessage },
						});
						triggerSetLoginFailed();
					} else {
						setLoginMessage(resp ? resp.message : t('genericErrorMessage'));
					}
				}
			} catch (error: any) {
				console.error(error);
			}
		},
		[
			dispatch,
			history,
			isBiometryEnabled,
			loginMessage,
			signInData?.keepSignedIn,
			triggerNewBiometricSession,
			triggerSetIsBiometryEnabled,
			triggerSetLoginFailed,
		],
	);

	const triggerBiometicLogin = useCallback(async () => {
		if (userData && isBiometryEnabled) {
			triggerBiometricScan();
			subscribeToBiometricScan((isSuccess, loginData) => {
				handleBiometricSuccess(loginData);
				if (!isSuccess && isAndroidNewApp) {
					history.push(APP_URL.login);
					triggerSetLoginFailed();
				}
			});
		} else {
			setTimeout(() => {
				history.push(APP_URL.login);
			}, 700);
		}
	}, [isBiometryEnabled, triggerBiometricScan, subscribeToBiometricScan, handleBiometricSuccess, history]);

	useEffect(() => {
		// window.addEventListener('focus', triggerBiometicLogin);
		// document.addEventListener('visibilitychange', triggerBiometicLogin);
		window.addEventListener('DOMContentLoaded', triggerBiometicLogin);

		return () => {
			// window.removeEventListener('focus', triggerBiometicLogin);
			// document.removeEventListener('visibilitychange', triggerBiometicLogin);
			window.removeEventListener('DOMContentLoaded', triggerBiometicLogin);
		};
	}, [triggerBiometicLogin]);

	return null;
};

export default AutoBiometricLogin;
